import React from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { Button, Grid } from "@mui/material";
import { setSuccessNotification } from '../../../actions/notificationAction';
import { getSerialNumber } from '../../../utils/sharedFunctions'
import { CollectionApi } from "../../../api/collectionApi";
import {collectionSorting} from "../../../config/sortingLabels";
import useListingActions from '../../../hooks/useListingActions'
import useTranslation from '../../../hooks/useTranslation'
import StoreSelect from '../../../components/Shared/StoreSelect';
import { Category } from '../../../shared-components';
import { ListingPage, ListTable, ListTableActions } from '../../../shared-components'

const CollectionContainer = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { t } = useTranslation()
  const [selectedStore, setSelectedStore] = useState(() => JSON.parse(localStorage.getItem('collectionSelectedStore')) || null);

  const handleExtraParameters = () => {
    if (selectedStore) {
      return { store_id: selectedStore.id }
    } else {
      return {}
    }
  }

  const {
    data,
    count,
    page,
    perPage,
    searchTerm,
    setData,
    sortOptionSelected,
    handlerForSearchingAndSortingChange,
    fetchData
  } = useListingActions('collections', CollectionApi.getCollections, 'latest', handleExtraParameters );

  const handleStoreChange = (e, value) => {
    setSelectedStore(value)
    localStorage.setItem('collectionSelectedStore', JSON.stringify(value))
    fetchData({ page: 1, per_page: perPage, q: searchTerm, sort_by: sortOptionSelected, ...value && {store_id: value.id} }, true)
  }

  const deleteCollection = async (collection) => {
    await CollectionApi.deleteCollection(collection, collection.store_id)
    setData(data.filter(cat => collection.id !== cat.id))
    dispatch(setSuccessNotification({ message: t('response_messages.collection_deleted_successfully')}))
  }

  const tableContent = collectionTableContent(deleteCollection, data, page, perPage)

  const tableActions = (
    <ListTableActions
      searchText={t('labels.search_collections')}
      searchTerm={searchTerm}
      sortOptionSelected={sortOptionSelected}
      getData={handlerForSearchingAndSortingChange}
      translateText={t}
      sortOptions={collectionSorting}
    />
  )

  const actions = (
    <Grid container justifyContent="flex-end" spacing={1}>
      <Grid item>
        <StoreSelect selectedStore={selectedStore} onChange={handleStoreChange} />
      </Grid>
      {selectedStore && (
      <Grid item>
        <Button
          color="primary"
          variant="contained"
          onClick={() => history.push(`/admin/collections/new?store_id=${selectedStore.id}`)}>
          {t('labels.create_collection')}
        </Button>
      </Grid>
    )}
    </Grid>
  )

  return (
    <ListingPage
      title={t('labels.menu.collections')}
      actions={actions}
      table={(<ListTable
        tableHeadings={tableContent.tableHeading}
        tableContent={tableContent.tableBody}
        tableActions={tableActions}
        count={count}
        page_no={page}
        onPageChange={(event, pageNo) => handlerForSearchingAndSortingChange('page', pageNo + 1)}
        handleChangeRowsPerPage={(event) => handlerForSearchingAndSortingChange('pageSize', event.target.value)}
        rowsPerPage={perPage}
        rowsControl={true} />
      )} />
  )
}

const collectionTableContent = (deleteCollection, collections=[], page_no, per_page) => {
  const { t } = useTranslation()
  const history = useHistory();
  const handleEdit = (collection) => {
    history.push({
      pathname: `/admin/collections/edit/${collection.id}`,
      state: { collectionName: collection.name },
    });
  };
  const collectionBody = collections.map((collection, i) => (
    <Category key={collection.id} {...collection} deleteCategory={() => deleteCollection(collection)} index={getSerialNumber(page_no, per_page, i)} handleEdit={handleEdit}/>
  ));
  return { tableBody: collectionBody, tableHeading: [t('labels.id') , '',t('labels.name') ,t('labels.visible_on_homepage'), t('labels.public'), t('labels.action')] }
}
  
export default CollectionContainer
